import { useBootstrap } from '@/store/bootstrap'
import { permMiddleware } from '@/router/guards/permissions'
import { validateRouteMiddleware } from '@/router/guards/validateRoute'

export const validateAppRoute = async (to) => {
  // The layout performs these checks after its initial bootstrap, before
  // mounting router-view. Once ready, regular navigation uses this guard.
  if (to.meta.requireBootstrap && !useBootstrap().isReady) return
  return permMiddleware(to) || (await validateRouteMiddleware(to))
}
